var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { setColor } from '../icon.utilities';
export function SAIconWarning(_a) {
    var size = _a.size, colorVariant = _a.colorVariant, onClick = _a.onClick, icon = _a.icon, theme = _a.theme, additionalProps = __rest(_a, ["size", "colorVariant", "onClick", "icon", "theme"]);
    var iconTheme = useContext(ThemeContext);
    var color = setColor(iconTheme, colorVariant, 'tertiary');
    var renderSize = size !== null && size !== void 0 ? size : '100px';
    return (React.createElement("svg", __assign({}, additionalProps, { width: renderSize, height: renderSize, viewBox: "0 0 100 100", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }),
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("g", { transform: "translate(11.000000, 11.000000)", fillRule: "nonzero" },
                React.createElement("circle", { fill: color, cx: "39", cy: "39", r: "39" }),
                React.createElement("path", { d: "M38.9532,63.1722 C40.7316,63.1722 42.1356,62.6808 43.1652,61.698 C44.1948,60.7152 44.7096,59.4048 44.7096,57.7668 C44.7096,56.1288 44.1948,54.8301 43.1652,53.8707 C42.1356,52.9113 40.7316,52.4316 38.9532,52.4316 C37.2684,52.4316 35.9112,52.9113 34.8816,53.8707 C33.852,54.8301 33.3372,56.1288 33.3372,57.7668 C33.3372,59.4048 33.852,60.7152 34.8816,61.698 C35.9112,62.6808 37.2684,63.1722 38.9532,63.1722 Z M41.9016,47.7984 L43.7268,36.3558 L43.7268,13.26 L34.32,13.26 L34.32,36.3558 L36.1452,47.7984 L41.9016,47.7984 Z", fill: "#FFFFFF" })))));
}
//# sourceMappingURL=icon.warning.component.js.map